import { VibeType } from "../types/VibeType";

export function vibeTypeToText(vibe: VibeType): string {
  switch (vibe) {
    case VibeType.AfterWork:
      return "After Work";
    case VibeType.DateNight:
      return "Date Night";
    case VibeType.Serious:
      return "Serious";
    case VibeType.Social:
      return "Social";
  }
}
